import SelectType from './SelectType'

export default SelectType
